/* 📦 LIBS */
import { ResponsivePie } from "@nivo/pie";

/* 🎨 STYLES */
import { Container } from "./styles";

const Graph = ({data})=>{

    return(
        <Container>
            <ResponsivePie
                data={data}
                margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                innerRadius={0}
                padAngle={0}
                cornerRadius={0}
                activeOuterRadiusOffset={10}
                enableArcLinkLabels={false}
                enableArcLabels={false}
                colors= {['#C1E0D6', '#33CC99']}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        </Container>
    );
}

export default Graph;